import React from 'react';
import PropTypes from 'prop-types';

export const Save = ({ width, height, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M17.5 5.833v10c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.177.49H4.167c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h10L17.5 5.833Zm-1.667.709-2.375-2.375H4.167v11.666h11.666V6.542ZM10 15c.694 0 1.285-.243 1.77-.73.487-.485.73-1.076.73-1.77s-.243-1.285-.73-1.77A2.411 2.411 0 0 0 10 10c-.694 0-1.285.243-1.77.73a2.41 2.41 0 0 0-.73 1.77c0 .694.243 1.285.73 1.77.485.487 1.076.73 1.77.73ZM5 8.333h7.5V5H5v3.333Zm-.833-1.791v9.291V4.167v2.375Z'
    />
  </svg>
);

Save.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Save.defaultProps = {
  width: 24,
  height: 24,
};
